<app-modal [modalTitle]="modalTitle" [modalId]="modalId" (closeModal)="closeModalButtonTrigger()">
  <div modalBody>
    <form>
      <div class="table-responsive scroll" [ngClass]="{ center: sharedItems && sharedItems.length === 0 }">
        <table class="table" *ngIf="sharedItems.length !== 0">
          <caption></caption>
          <thead class="header-style">
            <tr>
              <th class="header-cell cell-1">{{ 'SHARING' | translate }}</th>
              <th class="header-cell cell-2">{{ 'AUTHORITY' | translate }}</th>
              <th class="header-cell cell-3">{{ 'NOTE' | translate }}</th>
              <th class="header-cell cell-4">{{ 'LEAVE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of sharedItems; let i = index">
              <ng-container *ngIf="!item.groupShare">
                <tr [id]="'rowId' + i">
                  <td [id]="'personShareId' + i">
                    <div class="person">
                      <div *ngIf="item.userInfoDto" class="person-picture">
                        <app-profile-image [firstName]="item.userInfoDto.firstName" [lastName]="item.userInfoDto.lastName" [image]="item.userInfoDto.imageId"></app-profile-image>
                      </div>
                      <div class="person-info">
                        <div class="name" *ngIf="hasRtukUrl; else noRtukUrl">
                          {{ trimStringPipe.transform(commonService.removeLastWord(item.userInfoDto?.firstName!) + ' ' + item.userInfoDto?.lastName, 20) }}</div
                        >
                        <ng-template #noRtukUrl>
                          <div class="name"> {{ trimStringPipe.transform(item.userInfoDto?.firstName! + item.userInfoDto?.lastName, 20) }}</div>
                        </ng-template>
                        <div class="email" title="{{ item.userInfoDto?.email }}">{{ item.userInfoDto?.email }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="mt-2 permission" [id]="item.permission === 'VIEW' ? 'VIEWUSER' + i : 'EDITUSER' + i">{{
                      item.permission === 'VIEW' ? ('VIEW' | translate) : ('EDIT' | translate)
                    }}</div>
                  </td>
                  <td>
                    <div class="note mt-6" (click)="toggleNote(item)" [id]="'toggleNoteId' + i">
                      <img src="/assets/images/suite/storage/note.svg" alt="" />
                    </div>
                  </td>
                  <td>
                    <div (click)="showLeaveShareSnackbar(item)" class="remove mt-2 ml-5" [id]="'leaveShareId' + i">
                      <img src="/assets/images/suite/storage/close-danger.svg" alt="" />
                    </div>
                  </td>
                </tr>
                <tr [ngClass]="{ 'note-size': item.showInput }">
                  <td colspan="5" *ngIf="item.showInput">
                    <header class="note-header mb-1">{{ 'SHARE_NOTE' | translate }}</header>
                    <input
                      type="text"
                      name="note"
                      [(ngModel)]="item.shareNote"
                      [ngModelOptions]="{ standalone: true }"
                      [value]="item.shareNote"
                      readonly
                      class="note-style form-control"
                    />
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="item.groupShare">
                <tr>
                  <td [id]="'groupShareId' + i">
                    <div class="person">
                      <div *ngIf="item.groupInfoDto" class="person-picture">
                        <img id="profile-image-placeholder" class="small-size" *ngIf="!item.groupInfoDto.imageId; else image" src="/assets/images/suite/groups/thumb.svg" alt="" />
                        <ng-template #image>
                          <app-profile-image [image]="item.groupInfoDto.imageId"></app-profile-image>
                        </ng-template>
                      </div>
                      <div class="person-info">
                        <div class="name">{{ item.groupInfoDto?.name }}</div>
                        <div class="email">{{ item.groupInfoDto?.userCount }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="mt-2 permission">{{ item.permission === 'VIEW' ? ('VIEW' | translate) : ('EDIT' | translate) }}</div>
                  </td>
                  <td>
                    <div class="note mt-6" (click)="toggleNote(item)" [id]="'noteId' + i">
                      <img src="/assets/images/suite/storage/note.svg" alt="" />
                    </div>
                  </td>
                  <td>
                    <div *ngIf="item.userInfoDto?.email === myEmail" (click)="showLeaveShareSnackbar(item)" class="remove mt-2 ml-5" [id]="'leaveShareId' + i">
                      <img src="/assets/images/suite/storage/close-danger.svg" alt="" />
                    </div>
                  </td>
                </tr>
                <tr [ngClass]="{ 'note-size': item.showInput }">
                  <td colspan="5" *ngIf="item.showInput">
                    <header class="note-header">{{ 'SHARE_NOTE' | translate }}</header>
                    <input
                      type="text"
                      name="note"
                      [(ngModel)]="item.shareNote"
                      [ngModelOptions]="{ standalone: true }"
                      [value]="item.shareNote"
                      class="note-style form-control"
                      [id]="'shareNoteId' + i"
                      readonly
                    />
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <div class="warning" *ngIf="sharedItems?.length === 0">
          <i class="ti ti-info-circle"></i>
          <span class="ml-2">{{ 'SHARE_REMOVE' | translate }}</span>
        </div>
      </div>
    </form>
  </div>
  <div modalFooter>
    <button #btnRefmodal class="btn btn-primary btn-md btn-style" data-bs-dismiss="modal">{{ 'CLOSE' | translate }}</button>
  </div>
</app-modal>
